import { EnvironmentProviders, inject, provideAppInitializer } from "@angular/core";
import { Meta } from "@angular/platform-browser";
import { environment } from "src/environments/environment";
import { isLocal } from "../constants/is-development";
import { EnvironmentId } from "../enums/environment-id.enum";

/**
 * Sets the initial Robots Meta Tag value.
 *
 * It can change during Route navigation end
 */
export function setRobotsMetaTagValueOnAppInit(): EnvironmentProviders {
  return provideAppInitializer((): void => {
    // Initial value only, it can change during route navigation end
    if (environment.id !== EnvironmentId.Production && !isLocal) {
      const meta = inject(Meta);
      // Get the existing values
      const robotsTagList = meta.getTags("name='robots'") ?? [];
      const contentSet: Set<string> = new Set(robotsTagList.flatMap((x) => x.content?.split(/\s*,\s*/) ?? []));
      // If missing "noindex" on non-production, re-sets the tag with all values
      if (!contentSet.has("noindex")) {
        contentSet.add("noindex");
        // Remove and re-create element for better browser support
        robotsTagList.forEach((tag) => meta.removeTagElement(tag));
        meta.updateTag({ name: "robots", content: Array.from(contentSet.values()).join(", ") });
      }
    }
  });
}
